import React, { useContext, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import { SkycityContext } from '../../lib/SkycityProvider'
import SenseiParams from '../SsImageCutoutOnSensei/SenseiParams'

import { error } from '@react/react-spectrum/Toast'
import Button from '@react/react-spectrum/Button'

import axios from 'axios'

import {
    getFilename,
    getFilenameWithoutExt,
    getTempDirectory,
    getSenseiHeaders,
    checkFileType,
    getEndpointByRegion
} from '../../lib/skycity.js'

import {
    ssApiCall,
    getSenseiStatus
} from '../../lib/ccApi.js'

import {
    retrieveRendition,
    retrievePreSignedDownloadUrl
} from '../../lib/acpApi.js'

import {
    exploreIndexDocument,
    exploreHomeDirectory,
    getLinks

} from '../../lib/acpApi.js'

const uuid = require('uuid/v4')

export default function Operation (files) {
    const {
        inputFiles,
        errorOptions,
        dispatch,
        region
    } = useContext(SkycityContext)

    const [params, setParams] = useState({
        serviceMode: [
            { label: 'Cutout', value: 'cutout', selected: true },
            { label: 'Mask', value: 'mask', selected: false }
        ],
        maskFormat: [
            { label: 'JPEG', value: 'jpeg', selected: true },
            { label: 'PNG', value: 'png', selected: false },
            { label: 'webP', value: 'webp', selected: false }
        ],
        outputQuality: 95,
        trim: false
    })

    function formatParams (params) {
        const mode = params.serviceMode.find((mode) => mode.selected).value
        const maskFormat = params.maskFormat.find((format) => format.selected).value
        const trim = params.trim
        const quality = Number.parseInt(params.outputQuality)
        return {
            mode: mode,
            mask_format: `image/${maskFormat}`,
            trim: trim,
            output_quality: quality
        }
    }

    async function start (curFile) {
        console.log('START CALLED')
        // replaced with RAPI

        // 1. Explore the Index Document and get the Primary URL of the home Directory
        const homeDirectoryPrimaryUrl = await exploreIndexDocument()

        // 2. Explore the home Directory and get the Create URL of the Cloud Documents Directory
        const exploreHomeDirectoryResponse = await exploreHomeDirectory(
            homeDirectoryPrimaryUrl
        )
        const tempURN = exploreHomeDirectoryResponse.tempUrn
        const outputFileBasename = `cutout_${uuid()}_${curFile.shortName}`
        const formattedParams = formatParams(params)
        const outputFileExtension = (formattedParams.mask_format === 'image/jpeg') ? 'jpg' : (formattedParams.mask_format === 'image/png') ? 'png' : 'webp'
        const filePath = curFile.path
        const codePayload = {
            contentAnalyzerRequests: {
                'sensei:name': 'ImageCutout V4 Async on CPF',
                'sensei:invocation_mode': 'asynchronous',
                'sensei:invocation_batch': false,
                'sensei:in_response': false,
                'sensei:engines': [
                    {
                        'sensei:execution_info': {
                            'sensei:engine': 'Feature:autocrop:Service-e4c2aec8002943a797840574eab514eb'
                        },
                        'sensei:params': formattedParams,
                        'sensei:inputs': {
                            image_in: {
                                'dc:format': checkFileType(curFile.type),
                                'sensei:repoType': 'HTTP',
                                'repo:path': filePath
                            }
                        },
                        'sensei:outputs': {
                            mask: {
                                'repo:id': tempURN,
                                'dc:format': `${formattedParams.mask_format}`,
                                'sensei:repoType': 'RAPI',
                                'repo:resource': {
                                    reltype: 'http://ns.adobe.com/adobecloud/rel/create',
                                    path: `${outputFileBasename}.${outputFileExtension}`
                                }
                            },
                            metadata_out: {
                                'repo:id': tempURN,
                                'dc:format': 'application/json',
                                'sensei:repoType': 'RAPI',
                                'repo:resource': {
                                    reltype: 'http://ns.adobe.com/adobecloud/rel/create',
                                    path: `${outputFileBasename}.json`
                                }
                            }
                        }
                    }
                ]
            }
        }

        const formData = new FormData()
        formData.append('contentAnalyzerRequests', JSON.stringify(codePayload.contentAnalyzerRequests))
        const config = {
            file: curFile,
            url: `${getEndpointByRegion(region)}/predict`,
            method: 'POST',
            mode: 'cors',
            timeout: 90000,
            headers: getSenseiHeaders(),
            payload: codePayload,
            body: {
                formData: formData
            }
        }

        /* *********************************** */
        dispatch({ type: 'set-codes', payload: { config: config } })

        try {
            const response = await ssApiCall(config)

            if (response && response.status < 400) {
                const senseiStatusResponse = await getSenseiStatus(response.getResponseHeader('location'))

                if (senseiStatusResponse && senseiStatusResponse.status === '200') {
                    const outputHref = `${getTempDirectory()}/${outputFileBasename}.${outputFileExtension}`
                    const response = { ...senseiStatusResponse }
                    const assetLinksResponse = await getLinks(response['sensei:outputs'].mask['repo:id'])
                    const renditionPath = assetLinksResponse.data._links['http://ns.adobe.com/adobecloud/rel/rendition'][0].href.split('{')[0]
                    const primaryUrl = assetLinksResponse.data._links['http://ns.adobe.com/adobecloud/rel/primary'][0].href
                    const preSignedDownloadUrl = await retrievePreSignedDownloadUrl(primaryUrl)
                    const defaultRendition = await retrieveRendition(
                        renditionPath,
                        0,
                        'image/jpeg'
                    )
                    files.push({
                        inputFile: curFile,
                        name: getFilename(outputHref),
                        shortName: getFilenameWithoutExt(outputHref),
                        path: outputHref,
                        outputThumbnail: defaultRendition,
                        output: defaultRendition,
                        outputToDownload: preSignedDownloadUrl
                    })
                    dispatch({
                        type: 'skycity-success',
                        payload: {
                            files: files,
                            response: response,
                            loading: false,
                            wait: false
                        }
                    })
                } else {
                    const errMsg = senseiStatusResponse.errors ? `${JSON.stringify(senseiStatusResponse.errors, null, 2)}` : `ERROR with ${config.url}`
                    errorOccured(`${JSON.stringify(curFile)} - ${errMsg}`, senseiStatusResponse)
                }
            } else {
                const errMsg = response ? `${JSON.stringify(response.response, null, 2)}` : `ERROR with ${config.url}`
                errorOccured(`${errMsg}`, response)
            }
        } catch (e) {
            error(`${__('error_msg_title')}: ${e}`, {
                timeout: 0
            })
            errorOccured(`${__('error_msg_title')}: ${e}`)
        }
    }

    function run (e) {
        try {
            dispatch({ type: 'skycity-run', payload: {} })

            files = []
            const funcArray = []
            inputFiles.forEach(curFile => {
                funcArray.push(start(curFile))
            })
            axios.all(funcArray)
                .then((res) => {
                    // then
                })
                .catch((err) => {
                    const errMsg = `ERROR: ${JSON.stringify(err)}`
                    errorOccured(errMsg)
                })
                .finally(() => {
                    console.log('finally...')
                })
        } catch (e) {
            error(`${__('error_msg_title')}: ${e}`, {
                timeout: 0
            })
            errorOccured(`${__('error_msg_title')}: ${e}`)
        }
    }

    function isRunDisabled () {
        if (inputFiles && inputFiles.length > 0) {
            return false
        }
        return true
    }

    function errorOccured (errMsg, res) {
        console.log(errMsg)
        error(errMsg.slice(0, errorOptions.wordSlice), {
            onClose: () => console.log('close'),
            timeout: errorOptions.msgTimeout
        })
        dispatch({ type: 'error-occured', payload: { errMsg: errMsg, response: res, loading: false, wait: false } })
    }

    try {
        return <div>
            <SenseiParams params={params} setParams={setParams} />
            <div className="adobe-skycity-button-right">
                <Button variant="cta" onClick={e => run(e)} disabled={isRunDisabled()}>{__('btn_run')}</Button>
            </div>
        </div>
    } catch (e) {
        console.log(e)
        error(`${__('error_msg_title')}: ${e}`, {
            timeout: 0
        })
    }
}
